"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeViewModel = void 0;
const tsyringe_1 = require("tsyringe");
const BaseViewModel_1 = require("../../core/render/BaseViewModel");
const globalSymbols_1 = require("../../globalSymbols");
let HomeViewModel = class HomeViewModel extends BaseViewModel_1.BaseViewModel {
    constructor(songManager, plugins) {
        super();
        this.songManager = songManager;
        this.plugins = plugins;
    }
    getNumberOfSongs() {
        return __awaiter(this, void 0, void 0, function* () {
            let songs = yield this.songManager.getSongs();
            return songs.length;
        });
    }
    getSongs() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.songManager.getSongs();
        });
    }
    switchSong(songId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.songManager.switchSong(songId);
        });
    }
    getNumberOfPlugins() {
        return this.plugins.length;
    }
};
HomeViewModel = __decorate([
    tsyringe_1.injectable(),
    __param(0, tsyringe_1.inject(globalSymbols_1.TSongManager)), __param(1, tsyringe_1.injectAll(globalSymbols_1.TPlugins)),
    __metadata("design:paramtypes", [Object, Array])
], HomeViewModel);
exports.HomeViewModel = HomeViewModel;
//# sourceMappingURL=HomeViewModel.js.map